module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "v-if": _vm.value && _vm.value.source
    }
  }, [_c('h4', [_vm._v("\n        " + _vm._s(_vm.value.title) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "embed-responsive embed-responsive-16by9",
    attrs: {
      "align": "center"
    }
  }, [_c('video', {
    staticClass: "embed-responsive-item",
    attrs: {
      "controls": "controls"
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.value.source
    }
  })])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-fd873a4c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fd873a4c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./ClientApp/components/video-player/video-player.vue.html
// module id = 1139
// module chunks = 0